import userApi from 'apis/userApi';
import LoadingIcon from 'components/loading/LoadingIcon';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import accountStyles from './account-option.style';

interface LocationState {
    id?: number;
    loginname?: string;
    nickname?: string;
}

function AgentTeamBalance() {
    const location = useLocation();
    const state = location.state as LocationState | null;

    const [loginName, setLoginName] = useState('');
    const [nickName, setNickName] = useState('');
    const [teamBalance, setTeamBalance] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (state?.id) {
            getData(state.id);
            setLoginName(state.loginname || '');
            setNickName(state.nickname || '');
        } else {
            getData();
        }
    }, []);

    const getData = async (id?: number) => {
        setLoading(true);
        try {
            const { data } = id
                ? await userApi.agentUserTeamBalance({ id })
                : await userApi.agentTeamBalance({});

            if (!data.msg) {
                setTeamBalance(data.tbalance);
                if (!id) {
                    setLoginName(data.loginname || '');
                    setNickName(data.nickname || '');
                }
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className={accountStyles.wrap}>
                <h6 className={accountStyles.title}>Số Dư Nhóm</h6>
                <div className="table-common">
                    <div className="col-table">
                        <div className="col-header">
                            <p>{loginName}</p>
                            <span>Biệt danh: <strong>{nickName}</strong></span>
                        </div>
                        <div className="row">
                            <div className="col">
                                <p>Tài khoản:</p>
                                <strong>{loginName}</strong>
                            </div>
                            <div className="col">
                                <p>Biệt danh:</p>
                                <strong>{nickName}</strong>
                            </div>
                            <div className="col">
                                <p>Số dư nhóm:</p>
                                <strong className="text-success">{new Intl.NumberFormat().format(teamBalance || 0)}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

export default AgentTeamBalance;
